module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.player.picture_path) ? _c('figure', {
    staticClass: "image is-cover is-round",
    class: 'is-' + _vm.size + 'x' + _vm.size
  }, [_c('img', {
    attrs: {
      "src": _vm.player.picture_path,
      "alt": _vm.player.name
    }
  })]) : _c('div', {
    staticClass: "caption image is-round",
    class: 'is-' + _vm.size + 'x' + _vm.size
  }, [_vm._v("\n  " + _vm._s(_vm.player.initials) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f1dface","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player/PlayerAvatar.vue
// module id = 365
// module chunks = 9